<td-wb-icon size="16"
            [iconId]="iconId()"
            [inline]="true" />
<ng-content />
